var _path, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialmediaGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.003 0 C7.17 0 0.008 7.162 0.008 15.997 0.008 23.064 4.59 29.06 10.948 31.176 11.748 31.322 12 30.848 12 30.424 12 30.044 12.008 28.982 12 27.647 7.551 28.614 6.629 25.54 6.629 25.54 5.902 23.692 4.854 23.2 4.854 23.2 3.402 22.208 4.963 22.227 4.963 22.227 6.568 22.34 7.414 23.876 7.414 23.876 8.841 26.319 11.157 25.613 12.068 25.205 12.214 24.171 12.628 23.466 13.085 23.066 9.533 22.662 5.799 21.29 5.799 15.16 5.799 13.413 6.422 11.986 7.445 10.868 7.28 10.464 6.73 8.837 7.602 6.634 7.602 6.634 8.945 6.204 12 8.275 13.276 7.92 14.645 7.743 16.005 7.737 17.364 7.743 18.732 7.92 20.01 8.275 23.065 6.205 24.406 6.634 24.406 6.634 25.278 8.837 24.729 10.464 24.565 10.868 25.588 11.986 26.209 13.413 26.209 15.16 26.209 21.306 22.469 22.658 18.905 23.053 19.479 23.548 20 24.508 20 26 L20 30.428 C20 30.856 20.258 31.329 21.07 31.174 27.422 29.055 32 23.062 32 15.997 32 7.162 24.838 0 16.003 0 Z",
    fill: "#ffffff",
    fillOpacity: 1,
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "group-1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "group-2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "group-3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "group-4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "group-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmediaGithub);
export default __webpack_public_path__ + "static/media/socialmedia-github.a3f8742329b21fad497c8bae4e0b9a24.svg";
export { ForwardRef as ReactComponent };